/* fit-autoplay.js — scroll-triggered muted video, resilient to section swaps.
 *
 * Why this is not an inline script inside the section it controls:
 * the homepage re-fetches ?sections=home-main-live and replaces that DOM after
 * load. innerHTML never executes <script> tags, and any element reference or
 * IntersectionObserver bound before the swap points at a detached node. So the
 * binding has to live outside the replaced region and re-attach when the
 * element reappears.
 *
 * Contract: any <video data-autoplay-src="..."> gets a muted, looping,
 * play-on-visible / pause-on-hidden behaviour. Nothing downloads until the
 * element is actually near the viewport.
 */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var BOUND = '__fitAutoplayBound';

  function bindOne(v) {
    if (!v || v[BOUND]) return;
    var src = v.dataset.autoplaySrc || v.dataset.src;
    if (!src) return;
    v[BOUND] = true;
    v.muted = true;                 // unmuted autoplay is blocked; belt and braces
    v.setAttribute('playsinline', '');

    var started = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (!started) { started = true; v.src = src; }
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else if (started && !v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35, rootMargin: '120px' });
    io.observe(v);
  }

  function scan() {
    var list = document.querySelectorAll('video[data-autoplay-src], video[data-src]');
    for (var i = 0; i < list.length; i++) bindOne(list[i]);
  }

  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);

  // Re-scan after the patch layer swaps section markup. Debounced; scan() is cheap.
  var t = 0;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(scan, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
